export type GalleryCategory =
  | 'exterior'
  | 'living'
  | 'kitchen'
  | 'bedrooms'
  | 'bathrooms'
  | 'waterView'
  | 'amenities'

export interface PropertyImage {
  id: string
  /** Original supplied filename — internal reference only, never shown as a caption. */
  fileName: string
  src: string
  altEn: string
  altEs: string
  categories: GalleryCategory[]
  /** Focal point kept correct across responsive crops. */
  objectPosition: string
  width: number
  height: number
}

const CDN = 'https://cdn.magicpatterns.com/uploads'

export const propertyImages: PropertyImage[] = [
  {
    id: 'exterior',
    fileName: '01-HERO-exterior-property.jpg',
    src: `${CDN}/bEJ4GL4kL7u6VCjpcg67qF/01-HERO-exterior-property.jpg`,
    altEn:
      'Exterior of the furnished townhome at 1039 Plantation Ln in Davenport, Florida.',
    altEs:
      'Exterior de la townhome amoblada en 1039 Plantation Ln en Davenport, Florida.',
    categories: ['exterior'],
    objectPosition: '50% 45%',
    width: 708,
    height: 943,
  },
  {
    id: 'openKitchenLiving',
    fileName: '02-open-kitchen-living-water-view.png',
    src: `${CDN}/iUEkhVHoTS5MenwZnmutWV/02-open-kitchen-living-water-view.png`,
    altEn: 'Open-concept kitchen and living room with a water view.',
    altEs: 'Cocina y sala de concepto abierto con vista al agua.',
    categories: ['living', 'kitchen', 'waterView'],
    objectPosition: '50% 50%',
    width: 1471,
    height: 1080,
  },
  {
    id: 'kitchenIsland',
    fileName: '03-kitchen-island.png',
    src: `${CDN}/ornYDjYDuXESKCdt7LNBLi/03-kitchen-island.png`,
    altEn: 'Modern furnished kitchen with island and included appliances.',
    altEs: 'Cocina moderna amoblada con isla y electrodomésticos incluidos.',
    categories: ['kitchen'],
    objectPosition: '50% 50%',
    width: 1471,
    height: 1080,
  },
  {
    id: 'diningArea',
    fileName: '04-dining-area.png',
    src: `${CDN}/2x6dfNQaJZtKtq2znuh76r/04-dining-area.png`,
    altEn: 'Furnished dining area inside the Davenport townhome.',
    altEs: 'Comedor amoblado dentro de la townhome en Davenport.',
    categories: ['living'],
    objectPosition: '60% 55%',
    width: 1471,
    height: 1080,
  },
  {
    id: 'livingWaterView',
    fileName: '05-living-room-water-view.png',
    src: `${CDN}/tXcrMbW82T2L6z6xnGoBTr/05-living-room-water-view.png`,
    altEn: 'Furnished living room with relaxing water and pond views.',
    altEs: 'Sala amoblada con relajantes vistas al agua y al estanque.',
    categories: ['living', 'waterView'],
    objectPosition: '50% 40%',
    width: 1471,
    height: 1080,
  },
  {
    id: 'primaryBedroom',
    fileName: '06-primary-bedroom.png',
    src: `${CDN}/bY46saeuKBuV6SDCFBJw8y/06-primary-bedroom.png`,
    altEn: 'Furnished primary bedroom with natural light.',
    altEs: 'Habitación principal amoblada con luz natural.',
    categories: ['bedrooms'],
    objectPosition: '50% 50%',
    width: 1471,
    height: 1080,
  },
  {
    id: 'guestBedroom',
    fileName: '07-guest-bedroom.png',
    src: `${CDN}/k7x7VDXiK3GJ1mr8mNX4ne/07-guest-bedroom.png`,
    altEn: 'Furnished guest bedroom prepared for family members and visitors.',
    altEs:
      'Habitación de invitados amoblada, preparada para familiares y visitantes.',
    categories: ['bedrooms'],
    objectPosition: '50% 50%',
    width: 1471,
    height: 1080,
  },
  {
    id: 'bunkBedroom',
    fileName: '08-bunk-bedroom.png',
    src: `${CDN}/eBNbLSPPe52dDfnt39ajto/08-bunk-bedroom.png`,
    altEn: 'Furnished bunk bedroom designed for families and younger guests.',
    altEs:
      'Habitación con literas amoblada, diseñada para familias y huéspedes más jóvenes.',
    categories: ['bedrooms'],
    objectPosition: '40% 50%',
    width: 1471,
    height: 1080,
  },
  {
    id: 'bathroom',
    fileName: '09-bathroom.png',
    src: `${CDN}/qQxNA4Kg4GtLLwLhBkX7Vg/09-bathroom.png`,
    altEn: 'Bathroom inside the furnished Davenport townhome.',
    altEs: 'Baño dentro de la townhome amoblada en Davenport.',
    categories: ['bathrooms'],
    objectPosition: '50% 50%',
    width: 1471,
    height: 1080,
  },
  {
    id: 'patioPond',
    fileName: '10-patio-pond-view.png',
    src: `${CDN}/3uSeF6TebygyRnvNuquodb/10-patio-pond-view.png`,
    altEn: 'Patio overlooking the water and pond behind the townhome.',
    altEs: 'Patio con vista al agua y al estanque detrás de la townhome.',
    categories: ['waterView'],
    objectPosition: '50% 45%',
    width: 1471,
    height: 1080,
  },
  {
    id: 'resortPool',
    fileName: '11-community-resort-pool.png',
    src: `${CDN}/pnDu83FsjwDW2vwy1eRPEw/11-community-resort-pool.png`,
    altEn:
      'Resort-style community swimming pool available to residents and guests.',
    altEs:
      'Piscina estilo resort de la comunidad, disponible para residentes e invitados.',
    categories: ['amenities'],
    objectPosition: '50% 55%',
    width: 1571,
    height: 1080,
  },
  {
    id: 'fitnessCenter',
    fileName: '12-community-fitness-center.png',
    src: `${CDN}/jQ13GL6KRpMpukbydnbucb/12-community-fitness-center.png`,
    altEn: 'Community fitness center with exercise equipment.',
    altEs: 'Gimnasio de la comunidad con equipos de ejercicio.',
    categories: ['amenities'],
    objectPosition: '50% 50%',
    width: 1571,
    height: 1080,
  },
  {
    id: 'waterPark',
    fileName: '13-community-water-park.png',
    src: `${CDN}/knFXVBCCVodM9yE1PFB5QL/13-community-water-park.png`,
    altEn: 'Community water park with pirate-ship play area.',
    altEs: 'Parque acuático de la comunidad con área de juegos de barco pirata.',
    categories: ['amenities'],
    objectPosition: '50% 50%',
    width: 1571,
    height: 1080,
  },
]

export function getImage(id: string): PropertyImage | undefined {
  return propertyImages.find((image) => image.id === id)
}

/** Gallery order: hero exterior first, then interiors, then community amenities. */
export const galleryOrder: string[] = [
  'exterior',
  'openKitchenLiving',
  'kitchenIsland',
  'diningArea',
  'livingWaterView',
  'primaryBedroom',
  'guestBedroom',
  'bunkBedroom',
  'bathroom',
  'patioPond',
  'resortPool',
  'fitnessCenter',
  'waterPark',
]

export const galleryImages: PropertyImage[] = galleryOrder
  .map((id) => getImage(id))
  .filter((image): image is PropertyImage => Boolean(image))
